<template>
    <div id="page-contacts" class="px-xl-0 px-4 overflow-hidden">
        <div class="row">
            <div class="col-xl-5 col-12 px-0">
                <div class="h1 labgrotesque-bold text-xl-center text-left">
                    {{ $t($route.meta.title) }}
                    <hr class="hr-title-mobile">
                </div>
            </div>

            <div class="col-xl-7 col-12 px-0">
                <span class="h1 text-red labgrotesque-bold cursor-pointer text-xl-center text-left" @click="viewContacts">
                    BISWISS Consulting Sagl
                </span>
            </div>
        </div>

        <mapsvg @viewContacts="viewContacts"></mapsvg>

        <div v-show="viewcontacts" id="contacts" @click="hiddenContacts($event)">
            <div class="row">
                <div class="col-xl-5">
                </div>

                <div class="col-xl-7 bg-white px-xl-0 px-4">
                    <div v-html="contacts" class="py-3"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MapSvg from '../mapsvg';

export default {
    name: "contacts",

    components: {
        "mapsvg": MapSvg
    },

    data() {
        return {
            viewcontacts: false,
            contacts: "test"
        }
    },

    created() {
        axios.get(this.$route.meta.api, this.$root.auth)
        .then(response => {
            this.contacts = response.data[0].field_body;

            this.$nextTick(function() {
                this.$root.animejs({
                    targets: '#page-contacts',
                    opacity: [0,1],
                    easing: "easeInOutQuad",
                    duration: 400
                });
            });
        });
    },

    mounted() {
        var thisObj = this;
        setTimeout(function() {
            var top = $("svg").offset().top;
            var heightWindow = $(window).height();
            $("#contacts").css("height", (heightWindow - top) + "px");
            if(thisObj.$root.getClassSize() !== "xl") {
                $("#contacts").css("top", top + "px");
                $("#contacts").css("left", 0 + "px");
            }
        }, 500);
    },

    methods: {
        viewContacts() {
            if(!this.viewcontacts) {
                var thisObj = this;
                this.$root.animejs({
                    targets: '#contacts',
                    opacity: [0,1],
                    easing: "linear",
                    duration: 500,
                    begin: function(anim) {
                        thisObj.viewcontacts = true;
                    }
                });

                this.$root.animejs({
                    targets: 'svg * :not(#biswiss-location)',
                    opacity: 0.2,
                    easing: "linear",
                    duration: 500
                });
            }
        },

        hiddenContacts(event) {
            if($(event.target).attr("id") == "contacts" && this.viewcontacts) {
                var thisObj = this;
                this.$root.animejs({
                    targets: '#contacts',
                    opacity: 0,
                    easing: "linear",
                    duration: 500,
                    complete: function(anim) {
                        thisObj.viewcontacts = false;
                    }
                });

                this.$root.animejs({
                    targets: 'svg *',
                    opacity: 1,
                    easing: "linear",
                    duration: 500
                });
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/contacts.vue